// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Remplacez les valeurs par celles de votre projet Firebase
const firebaseConfig = {
    apiKey: "AIzaSyAfHPCOV3WuDphQjSvRd7J_sgejlb9i7dE",
    authDomain: "tokoss-mars-hitech.firebaseapp.com",
    projectId: "tokoss-mars-hitech",
    storageBucket: "tokoss-mars-hitech.appspot.com",
    messagingSenderId: "253870383624",
    appId: "1:253870383624:web:c50057ae63d100cfc5a7bd",
    measurementId: "G-L9LMGVBYK2"
};

// Initialisez Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialisez Firestore
const firestore = getFirestore(firebaseApp);

export { firestore };
